import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import { Link } from 'react-router-dom';
import { TitleMediumTextLink } from './styles';

const CampaignLink = props => {
  const { renderMode } = useContext(AppContext);
  const { campaign, linkContent, onClick } = props;

  if (!linkContent) {
    return null;
  }

  if (renderMode === 'native') {
    return (
      <TitleMediumTextLink
        container="a"
        containerProps={{
          href: campaign.web_uri.mobile,
          'data-test': props['data-test'],
          onClick,
        }}
      >
        {linkContent}
      </TitleMediumTextLink>
    );
  }

  return (
    <TitleMediumTextLink
      container={Link}
      containerProps={{
        to: `${campaign.web_uri.responsive}${props.queryString || ''}`,
        'data-test': props['data-test'],
        onClick,
      }}
    >
      {linkContent}
    </TitleMediumTextLink>
  );
};

const { shape, string, node, func } = PropTypes;

CampaignLink.propTypes = {
  linkContent: node,
  queryString: string,
  campaign: shape({
    title: shape({
      short: string,
    }),
    description: shape({
      short: string,
    }),
    web_uri: shape({
      desktop: string,
      mobile: string,
    }),
  }).isRequired,
  className: string,
  'data-test': string,
  onClick: func,
};

CampaignLink.defaultProps = {
  linkContent: '',
  className: null,
  queryString: null,
  'data-test': undefined,
  onClick: undefined,
};

export default CampaignLink;
